"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartType = void 0;
exports.ChartType = Object.freeze({
    Global: 'global',
    Goal: 'goal',
    Partition: 'partition',
    XYAxis: 'xy_axis',
    Heatmap: 'heatmap',
    Wordcloud: 'wordcloud',
});
//# sourceMappingURL=index.js.map